import { render, staticRenderFns } from "./cuploader.vue?vue&type=template&id=33116e45&scoped=true"
import script from "./cuploader.vue?vue&type=script&lang=js"
export * from "./cuploader.vue?vue&type=script&lang=js"
import style0 from "./cuploader.vue?vue&type=style&index=0&id=33116e45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33116e45",
  null
  
)

export default component.exports